import { SignInWithMessage } from './SignInWithMessage';
export class SiwStacksMessage extends SignInWithMessage {
    async isMessageSigned(message, signature, address) {
        // INFO: This is a workaround to avoid a referenceError in the frontend
        const { verifyMessageSignature } = await import('micro-stacks/connect');
        const isValid = verifyMessageSignature({
            message,
            signature: signature,
            stxAddress: address,
        });
        return isValid;
    }
}
